import {
  Badge,
  BlockStack,
  Box,
  Button,
  Card,
  Icon,
  InlineStack,
  Text,
  ActionList,
  Popover,
  Modal,
} from "@shopify/polaris";
import React, { useState } from "react";
import { LocationIcon, MenuHorizontalIcon } from "@shopify/polaris-icons";
import "./index.css";
import AddressEditModal from "./AddressEditModal";
import {
  reqGetSettingAddress,
  reqGetShopifyProvinceData,
  reqPutSaveUserAddress,
} from "../../../../../api";
import { store } from "../../../../../store";
import { changeBannerData } from "../../../../../slice";
import ShopifyCountriesConfig from "../../../../../assets/ShopifyCountries";
const Index = ({ addressList, setAddressList, toastFun }) => {
  const [showEdit, setShowEdit] = useState(-1);
  // 地址数据
  const [addressData, setAddressData] = useState({
    id: "",
    first_name: "",
    last_name: "",
    address1: "",
    address2: "",
    phone: "",
    email: "",
    city: "",
    province: "",
    province_code: "",
    country: "",
    country_code: "",
    company: "",
    zip: "",
    option1: "",
    is_default: 0,
    provinceLabelText: "Province",
    lastNameError: "",
    address1Error: "",
    countryError: "",
    cityError: "",
    zipCodeError: "",
    phoneError: "",
    emailError: "",
    option1Error: "",
    provinceData: [],
    provinceCode: "",
    loadingProvinceData: false,
    editAddressModalActive: false,
    editRecordId: 0,
    saveDataLoading: false,
    operateAddressModalActive: false,
    operateType: "",
  });
  // 添加地址
  // 新增、修改地址信息
  const handleEditAddress = (recordKey = 0, recordId, bool) => {
    if (recordId === 0) {
      // 新增
      setAddressData((prev) => ({
        ...prev,
        editAddressModalActive: bool,
        id: 0,
        first_name: "",
        last_name: "",
        address1: "",
        address2: "",
        phone: "",
        email: "",
        city: "",
        province: "",
        province_code: "",
        country: "",
        country_code: "",
        company: "",
        zip: "",
        option1: "",
        is_default: 0,
        provinceLabelText: "Province",
        lastNameError: "",
        address1Error: "",
        countryError: "",
        cityError: "",
        zipCodeError: "",
        phoneError: "",
        emailError: "",
        option1Error: "",
        provinceData: [],
        provinceCode: "",
        loadingProvinceData: false,
        editRecordId: 0,
        saveDataLoading: false,
        operateAddressModalActive: false,
        operateType: "",
      }));
    } else {
      let data = addressList.list;
      setAddressData((prev) => {
        let params = {
          ...prev,
          editAddressModalActive: bool,
          editRecordId: recordId,
          first_name: bool ? data[recordKey].first_name : "",
          last_name: bool ? data[recordKey].last_name : "",
          lastNameError: "",
          company: bool ? data[recordKey].company : "",
          address1: bool ? data[recordKey].address1 : "",
          address1Error: "",
          address2: bool ? data[recordKey].address2 : "",
          country: bool ? data[recordKey].country : "",
          countryError: "",
          country_code: bool ? data[recordKey].country_code : "",
          province: bool ? data[recordKey].province : "",
          provinceCode: bool ? data[recordKey].province_code : "",
          city: bool ? data[recordKey].city : "",
          cityError: "",
          zip: bool ? data[recordKey].zip : "",
          zipCodeError: "",
          phone: bool ? data[recordKey].phone : "",
          email: bool ? data[recordKey].email : "",
          option1: bool ? data[recordKey].option1 : "",
          phoneError: "",
          emailError: "",
          option1Error: "",
        };
        if (bool) {
          // 获取是否有省份数据
          getShopifyProvinceData(data[recordKey].country_code);
        }
        return params;
      });
    }
  };
  const handleAddressInputChange = (value, field) => {
    if (field === "country_code") {
      let countryName = "";
      let provinceKeyText = "";
      for (let i = 0; i < ShopifyCountriesConfig.length; i++) {
        if (ShopifyCountriesConfig[i].value === value) {
          countryName = ShopifyCountriesConfig[i].label;
          provinceKeyText = ShopifyCountriesConfig[i].province_label;
          break;
        }
      }
      if (value !== addressData.country_code) {
        // 当前国家与之前不一样，获取省份数据
        getShopifyProvinceData(value);
      }
      setAddressData((prev) => ({
        ...prev,
        [field]: value,
        country_code: value,
        country: countryName,
        provinceLabelText: provinceKeyText,
        province: "",
        provinceCode: "",
        countryError: "",
        city: "",
        cityError: "",
      }));
    } else if (field === "provinceCode") {
      let array = addressData.provinceData;
      let provinceText = "";
      for (let j = 0; j < array.length; j++) {
        if (array[j].value === value) {
          provinceText = array[j].label;
          break;
        }
      }
      setAddressData((prev) => ({
        ...prev,
        [field]: value,
        province: provinceText,
      }));
    } else if (field === "last_name") {
      setAddressData((prev) => ({
        ...prev,
        [field]: value,
        lastNameError: "",
      }));
    } else if (field === "address1") {
      setAddressData((prev) => ({
        ...prev,
        [field]: value,
        address1Error: "",
      }));
    } else if (field === "city") {
      setAddressData((prev) => ({
        ...prev,
        [field]: value,
        cityError: "",
      }));
    } else if (field === "zip") {
      setAddressData((prev) => ({
        ...prev,
        [field]: value,
        zipCodeError: "",
      }));
    } else if (field === "email") {
      setAddressData((prev) => ({
        ...prev,
        [field]: value,
        emailError: "",
      }));
    } else if (field === "phone") {
      setAddressData((prev) => ({
        ...prev,
        [field]: value,
        phoneError: "",
      }));
    } else if (field === "option1") {
      let err_msg = "";
      // 挪威的税号检测
      if (addressData.country_code === "NO") {
        if (value !== "") {
          // 只支持输入以2或3开头的7位纯数字
          let regex = /^([23]\d{6})$/;
          if (!regex.test(value)) {
            err_msg =
              "Only supports input of 7-digit plain numbers starting with 2 or 3";
          }
        } else {
          err_msg = "VOEC is required for orders destined to Norway";
        }
      }
      setAddressData((prev) => ({
        ...prev,
        [field]: value,
        option1Error: err_msg,
      }));
    } else {
      setAddressData((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };
  // 获取shopify省份数据
  const getShopifyProvinceData = async (code = "") => {
    const params = {
      c: code,
    };
    setAddressData((prev) => ({
      ...prev,
      loadingProvinceData: true,
    }));
    const response = await reqGetShopifyProvinceData(params);
    if (response.code === "200") {
      let getData = response.data;

      // 修改地址时，初始化省份
      let init_province = addressData.province ? addressData.province : "";
      let init_provinceCode = addressData.provinceCode
        ? addressData.provinceCode
        : "";

      if (getData.length > 0) {
        if (init_province === "") {
          init_province = getData[0].label;
        }

        if (init_provinceCode === "") {
          init_provinceCode = getData[0].value;
        }
      } else {
        init_province = "";
        init_provinceCode = "";
      }
      setAddressData((prev) => ({
        ...prev,
        loadingProvinceData: false,
        provinceData: getData,
        province: init_province,
        provinceCode: init_provinceCode,
      }));
    } else {
      store.dispatch(
        changeBannerData({
          bannerData: {
            show: true,
            desc: response.msg,
          },
        })
      );
      // this.toggleToast(response.msg);
    }
  };

  // 校验收货地址信息
  const verifyAddress = (address) => {
    if (address) {
      let errorObj = {};
      if (!address.last_name) {
        errorObj.lastNameError = "Last name is required";
      }
      if (!address.address1) {
        errorObj.address1Error = "Address is required";
      }
      if (!address.country) {
        errorObj.countryError = "Please select a country";
      }
      if (!address.zip) {
        errorObj.zipCodeError = "Postal code is required";
      }
      if (!address.city) {
        errorObj.cityError = "City is required";
      }
      if (address.email) {
        let reg = /^[.a-zA-Z0-9_-]+@[.a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (!address.email.match(reg)) {
          errorObj.emailError = "Wrong email number format";
        }
      }
      // 巴西税号
      if (address.country_code === "BR" && !address.option1) {
        errorObj.option1Error = "CPF required";
      }
      // 挪威税号
      if (address.country_code === "NO" && !address.option1) {
        errorObj.option1Error = "VOEC required";
      }

      let isTrue = true;

      if (Object.keys(errorObj).length !== 0) {
        isTrue = false;
        setAddressData((prev) => ({
          ...prev,
          ...errorObj,
        }));
      }

      return isTrue;
    } else {
      setAddressData((prev) => ({
        ...prev,
        lastNameError: "Last name is required",
        address1Error: "Address is required",
        countryError: "Please select a country",
        zipCodeError: "Postal code is required",
        cityError: "City is required",
      }));
      return false;
    }
  };
  // 编辑地址
  // 删除地址
  const saveAddress = async (type) => {
    try {
      if (type === "") {
        return false;
      }
      let params = {
        type: type,
        id: addressData.editRecordId,
      };
      
      if (type === "update" || type === "add") {
        let isAllow = true;
        let shippingAddress = {
          first_name: addressData.first_name,
          last_name: addressData.last_name,
          address1: addressData.address1,
          address2: addressData.address2,
          phone: addressData.phone,
          city: addressData.city,
          province: addressData.province,
          province_code: addressData.provinceCode,
          country: addressData.country,
          country_code: addressData.country_code,
          company: addressData.company,
          zip: addressData.zip,
          email: addressData.email,
          option1: addressData.option1,
        };

        // 检验地址
        isAllow = verifyAddress(shippingAddress);
        if (!isAllow) {
          return false;
        }
        params.id = addressData.editRecordId;
        params.address = shippingAddress;
      }
      setAddressData((prev) => ({
        ...prev,
        saveDataLoading: true,
      }));
      let res = await reqPutSaveUserAddress(params);
      if (res.code === "200") {
        if (type === "add") {
          toastFun("Add successfully");
          let response = await reqGetSettingAddress();
          if (response.code === "200") {
            setAddressList((prev) => ({
              ...prev,
              list: response.data,
            }));
          }
        }
        if (type === "update") {
          setAddressList((prev) => ({
            ...prev,
            list: prev.list.map((item, index) => {
              if (item.id === addressData.editRecordId) {
                item.first_name = addressData.first_name;
                item.last_name = addressData.last_name
                item.address1 = addressData.address1
                item.address2 = addressData.address2
                item.phone = addressData.phone
                item.city = addressData.city
                item.province = addressData.province
                item.province_code = addressData.provinceCode
                item.country = addressData.country
                item.country_code = addressData.country_code
                item.company = addressData.company
                item.zip = addressData.zip
                item.email = addressData.email
                item.option1 = addressData.option1
              }
              return item;
            }),
          }));
          toastFun("Saved successfully");
        }
        if (type === "del") {
          setAddressList((prev) => ({
            ...prev,
            list: prev.list.filter((item, index) => {
              return item.id !== addressData.editRecordId;
            }),
          }));
          toastFun("Deleted successfully");
        }
        if (type === "mark") {
          setAddressList((prev) => ({
            ...prev,
            list: prev.list.map((item, index) => {
              if (item.id === addressData.editRecordId) {
                item.is_default = 1;
              } else {
                item.is_default = 0;
              }
              return item;
            }),
          }));
          toastFun("Set up successfully");
        }
        handleOperatePrompt(0, false, "");
      } else if (res.code === "505") {
        setAddressData((prev) => ({
          ...prev,
          lastNameError: res.data?.last_name,
          address1Error: res.data?.address1,
          countryError: res.data?.country,
          cityError: res.data?.city,
          phoneError: res.data?.phone,
          zipCodeError: res.data?.zip,
          emailError: res.data?.email,
          option1Error: res.data?.option1,
        }));
      } else {
        store.dispatch(
          changeBannerData({
            bannerData: {
              show: true,
              desc: res.msg,
            },
          })
        );
      }
      setAddressData((prev) => ({
        ...prev,
        saveDataLoading: false,
      }));
    } catch (error) {}
  };
  // 修改地址为默认
  // 操作地址提示弹窗
  const handleOperatePrompt = (recordId, bool, type) => {
    setAddressData((prev) => {
      let params = {
        ...prev,
        editRecordId: recordId,
        operateAddressModalActive: bool,
        operateType: type,
        saveDataLoading: false,
        editAddressModalActive:false
      }
      let data = {}
      if (recordId !== 0) {// 填充默认地址数据
        addressList.list.forEach((item, index) => {
          if (item.id === recordId) {
            data.first_name = addressData.first_name;
            data.last_name = addressData.last_name
            data.address1 = addressData.address1
            data.address2 = addressData.address2
            data.phone = addressData.phone
            data.city = addressData.city
            data.province = addressData.province
            data.province_code = addressData.provinceCode
            data.country = addressData.country
            data.country_code = addressData.country_code
            data.company = addressData.company
            data.zip = addressData.zip
            data.email = addressData.email
            data.option1 = addressData.option1
          }
        })
        params = {...params,...data}
      }
      return params;
    });
  };
  // 操作提示弹窗
  let operateTipsModal = (
    <Modal
      open={addressData.operateAddressModalActive}
      onClose={() => handleOperatePrompt(0, false, "")}
      title={
        addressData.operateType === "del" ? "Remove address" : "Mark as default"
      }
      primaryAction={{
        content:
          addressData.operateType === "del" ? "Delete" : "Mark as default",
        onAction: () => saveAddress(addressData.operateType),
        destructive: addressData.operateType === "del",
        loading: addressData.saveDataLoading,
      }}
      secondaryActions={[
        {
          content: "Cancel",
          onAction: () => handleOperatePrompt(0, false, ""),
        },
      ]}
    >
      <Modal.Section>
        <p>
          {addressData.operateType === "del"
            ? "Are you sure to remove this address?"
            : "Are you sure to set this address as default?"}
        </p>
      </Modal.Section>
    </Modal>
  );
  return (
    <Box>
      <Card>
        <BlockStack gap={400}>
          <Box>
            <InlineStack align="space-between" blockAlign="center" gap={200} wrap={false}>
              <Text variant="headingSm" as="h6">
                Address management
              </Text>
              {addressList?.list && addressList?.list?.length <= 4 ? (
                <Button
                  variant="plain"
                  removeUnderline
                  onClick={() => {
                    handleEditAddress(0, 0, true);
                  }}
                >
                  Add address
                </Button>
              ) : (
                ""
              )}
            </InlineStack>
            <Text as="p" tone="subdued">
              The shipping address for purchasing samples and redeeming points,
              allow to set 5 addresses.
            </Text>
          </Box>

          <Box>
            <BlockStack gap={400}>
              {addressList?.list &&
                addressList?.list.map((item, ind) => (
                  <Box key={ind} className="address_item_box">
                    <Card roundedAbove="xs">
                      <InlineStack
                        gap={200}
                        blockAlign="center"
                        align="space-between"
                      >
                        <Box>
                          <Icon source={LocationIcon} />
                        </Box>
                        <Box style={{ flex: 1 }}>
                          <InlineStack gap={200} align="start">
                            <Text as="p" fontWeight="medium">
                              {item.first_name + " " + item.phone}
                            </Text>
                            {item.is_default ? (
                              <Badge tone="info">Default</Badge>
                            ) : (
                              ""
                            )}
                          </InlineStack>
                          <Text as="p" tone="subdued">
                            {item.address1 +
                              " " +
                              item.address2 +
                              " " +
                              item.city +
                              " " +
                              item.province +
                              " " +
                              item.zip +
                              " " +
                              item.country}
                          </Text>
                        </Box>
                        <Box>
                          <Popover
                            active={showEdit === ind}
                            activator={
                              <Button
                                variant="tertiary"
                                onClick={() => {
                                  if (showEdit === ind) {
                                    setShowEdit(-1);
                                  } else {
                                    setShowEdit(ind);
                                  }
                                }}
                              >
                                <Icon source={MenuHorizontalIcon} tone="base" />
                              </Button>
                            }
                            autofocusTarget="first-node"
                            onClose={() => {
                              if (showEdit === ind) {
                                setShowEdit(-1);
                              } else {
                                setShowEdit(ind);
                              }
                            }}
                          >
                            <ActionList
                              actionRole="menuitem"
                              items={
                                item.is_default
                                  ? [
                                      {
                                        content: "Edit",
                                        onAction: () => {
                                          handleEditAddress(ind, item.id, true);
                                        },
                                      },
                                    ]
                                  : [
                                      {
                                        content: "Edit",
                                        onAction: () => {
                                          handleEditAddress(ind, item.id, true);
                                        },
                                      },
                                      {
                                        content: "Mark as default",
                                        onAction: () => {
                                          handleOperatePrompt(
                                            item.id,
                                            true,
                                            "mark"
                                          );
                                        },
                                      },
                                      {
                                        content: "Delete",
                                        destructive: true,
                                        onAction: () => {
                                          handleOperatePrompt(
                                            item.id,
                                            true,
                                            "del"
                                          );
                                        },
                                      },
                                    ]
                              }
                            />
                          </Popover>
                        </Box>
                      </InlineStack>
                    </Card>
                  </Box>
                ))}
            </BlockStack>
          </Box>
        </BlockStack>
      </Card>
      <AddressEditModal
        addressData={addressData}
        handleEditAddress={handleEditAddress}
        setAddressData={setAddressData}
        saveAddress={saveAddress}
        handleAddressInputChange={handleAddressInputChange}
      />
      {operateTipsModal}
    </Box>
  );
};

export default Index;
